import React from 'react';
import { createUseStyles } from 'react-jss';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { UserState } from '../user/UserState';
import { VideoBackground } from './VideoBackground';
import { CenteredMessageOverlay } from '../components/CenteredMessageOverlay';
import { HelperBeeButton } from '../helper-bee/HelperBeeButton';
import { NativeBeeChatButton } from '../helper-bee/NativeBeeChatButton';
import { DevSettings } from '../support/DevSettings';

const useStyles = createUseStyles({
    banner: {
        position: 'relative',
        top: 0,
        width: '100%',
        height: 300,
    },
    helperBeeContainer: {
        top: '50%',
        left: '50%',
        zIndex: 999,
        marginTop: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
        position: 'relative',
        transform: 'translate(-50%, -50%)'
    }
});

export const HomePageBanner: React.FC = () => {

    const classes = useStyles();

    const userState = useInstance(UserState);
    useSubscription(() => userState);
    const name = userState.state.firstName || '';
    const welcomeMessage = (name ? `Welcome, ${name}` : 'Welcome');

    const devSettings = useInstance(DevSettings);

    return (
        <div className={classes.banner}>
            <VideoBackground />
            <CenteredMessageOverlay>{welcomeMessage}</CenteredMessageOverlay>
            <div className={classes.helperBeeContainer}>
                <HelperBeeButton trackingFrom="Welcome" />
                {devSettings.showNativeBeaChat && (
                    <NativeBeeChatButton trackingFrom="Welcome" data-id="native-bea-chat-button" />
                )}
            </div>
        </div>
    );
};
